import { render } from "./foot.vue?vue&type=template&id=f1f0748a&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=f1f0748a&lang=scss&scoped=true"

import exportComponent from "/data/sg-h5/panther-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f0748a"]])

export default __exports__